import { Seg } from "@kitchen/ui";
import { useState } from "react";
import { AccuracyTab } from "./AccuracyTab.js";
import { AlertsTab } from "./AlertsTab.js";
import { HolidaysTab } from "./HolidaysTab.js";
import { TomorrowTab } from "./TomorrowTab.js";
import { TrendsTab } from "./TrendsTab.js";

export type ForecastTab = "tomorrow" | "alerts" | "trends" | "accuracy" | "holidays";

export function ForecastPage() {
  const [tab, setTab] = useState<ForecastTab>("tomorrow");

  return (
    <div className="stack" style={{ gap: "var(--s4)" }}>
      <div className="row wrap" style={{ alignItems: "center" }}>
        <Seg<ForecastTab>
          label="بخش‌های پیش‌بینی و هوشمندی"
          value={tab}
          onChange={setTab}
          options={[
            { value: "tomorrow", label: "پیش‌بینی فردا" },
            { value: "alerts", label: "هشدار افت سفارش" },
            { value: "trends", label: "روند واحدها" },
            { value: "accuracy", label: "دقت پیش‌بینی" },
            { value: "holidays", label: "تعطیلات" },
          ]}
        />
      </div>

      {tab === "tomorrow" && <TomorrowTab />}
      {tab === "alerts" && <AlertsTab />}
      {tab === "trends" && <TrendsTab />}
      {tab === "accuracy" && <AccuracyTab />}
      {tab === "holidays" && <HolidaysTab />}
    </div>
  );
}
